import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { getWordSegments, Passage } from './applyRule.ts';
import classnames from '../../../core/utils/classnames.tsx';

interface ChangedPassagesProps {
    passages: Passage[];
    isLabeled?: boolean;
}

const ChangedPassages = ({ passages, isLabeled = false }: ChangedPassagesProps) => {
    const { t } = useTranslation('config');
    const unchangedPassages = passages.filter(({ type }) => type === 'same').length;
    return (
        <div className={classnames('flex flex-col', isLabeled ? 'gap-3' : 'gap-2')}>
            {passages
                .filter(({ type }) => type !== 'same')
                .map((passage, index) => (
                    <div key={index} className="flex flex-col gap-1">
                        {isLabeled && (
                            <span className="text-xs font-medium text-content-medium">
                                {t(`configPage.fineTuning.apply.passage.${passage.type}`)}
                            </span>
                        )}
                        <div
                            className={classnames(
                                'whitespace-pre-wrap rounded-lg border border-solid border-line-weak',
                                'bg-surface-medium p-3 text-xs text-content-strong'
                            )}
                        >
                            {getWordSegments(passage.before, passage.after).map((segment, segmentIndex) => (
                                <span
                                    key={segmentIndex}
                                    className={classnames(
                                        segment.type === 'removed' &&
                                            'bg-surface-danger-weak text-content-danger-strong line-through',
                                        segment.type === 'added' &&
                                            'bg-surface-success-weak text-content-success-strong'
                                    )}
                                >
                                    {segment.text}
                                </span>
                            ))}
                        </div>
                    </div>
                ))}
            {unchangedPassages > 0 && (
                <span className="text-xs text-content-medium">
                    {t('configPage.fineTuning.apply.passagesSame', { count: unchangedPassages })}
                </span>
            )}
        </div>
    );
};

export default ChangedPassages;
